<template>
  <div>
    <div class="box"></div>
    <div class="box2">
        <el-menu :default-active="idx" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="0" @click="$router.push('live')">智慧住建</el-menu-item>
            <el-menu-item index="1" @click="$router.push('site')">智慧工地</el-menu-item>
            <el-menu-item index="2" @click="$router.push('schemeSafety')">智慧安全</el-menu-item>
            <el-menu-item index="3" @click="$router.push('schemeCartoon')">工程动画</el-menu-item>
            <el-menu-item index="4" @click="$router.push('schemeShowRoom')">项目展厅展馆</el-menu-item>
        </el-menu>
    </div>
    <div class="box3">
      <div class="main" v-for="item in dataList" :key="item.id" @click="siteClick(item.id)">
        <img class="lef" :src="item.img">
        <div>
          <p class="tit">{{ item.title }}</p>
          <p class="txt">{{ item.text }}</p>
        </div>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      idx: '4',
      dataList: [
        {
          id: 0,
          img: require('./img/room/1/1.jpg'),
          title: '长圳二期项目工地智慧展馆',
          text: '结合BIM技术、“大数据科技”创新风向，打造高品质并具有未来感的高科技展厅；智工地大数据中心应用视频监控，塔吊防碰撞系统，人险识别等实现对工地的标准化、信息化、智能化管理，堪称“工地最强大脑”。'
        },
        {
          id: 1,
          img: require('./img/room/2/1.png'),
          title: '长圳二期项目安全教育展厅',
          text: '通过系统化、交互式安全教育培训内容设置，实现认知教学、实景展现、模拟互动、离教于乐的多元化功能；特色区域包含机械设备、钢丝绳、高空作业、氧气乙炔、动火作业、安全标志爬架作业等多种认知教学方式，火灾消防、安全用电、现场急救等实操教学方式，安全带、安全帽使用体验，安全培训教室等。'
        }, {
          id: 2,
          img: require('./img/room/3/1.jpg'),
          title: '东莞地铁一号线松山湖站安全体验馆',
          text: '东莞地铁规模最大，设施最全的安全体验馆，曾获东莞常务副市长喻丽君肯定。'
        },{
          id: 3,
          img: require('./img/room/4/1.jpg'),
          title: '京广协同创新中心项目工地智慧展馆',
          text: '特色区域包含无人机巡检鸟瞰、项目大事记、动态样板引路、智工地大数据中心、安全教育一体化培训等；无人机巡检鸟瞰以上帝视角对项目状况进行全方位、360度巡检观察，更加真实的反映地物的实际情况。'
        },{
          id: 4,
          img: require('./img/room/5/1.jpg'),
          title: '梅园片区城市更新项目工地智慧展馆',
          text: '可以拖走的工地智慧展厅展厅由8个3m（宽）*6m（长）的集装箱拼接而成，施工项目结束后，可以将展厅进行拆分，并在新的项目上组装使用；特色区域包含：智想工地大数据中心，VR安全体验，党建VR体验，虚拟灭火体验，安全用电体验，工艺工法展示等。'
        },
        {
          id: 5,
          img: require('./img/room/6/1.jpg'),
          title: '南山区高新公寓棚户区改造项目工地智慧展馆',
          text: '项目从无到有，从施工到建成，仅用了15天时间，展现九象加速度和超高效率；特色区域包含智慧工地大数据中心、VR安全体验、A安全帽智能识别、全息投影、互动滑轨、全景三维漫游体验、装配式吊装操作教学等，兼具项目监控管理、成果展示、安全教育培训及体验互动等多种功能。'
        },
        {
          id: 6,
          img: require('./img/room/7/1.png'),
          title: '北山道站项目工地智慧展馆',
          text: '特色区域包含智慧工地数据中心，劳保用品认知教学区，安全教育讲评台，安全事故警示墙，BIM双屏互动，VR行走平台，实操教学体验，盾构监控；实操教学体验让工人亲身经历施工过程突发的各种危险场景，感受违规操作的后果；强化安全意识。'
        },
        {
          id: 7,
          img: require('./img/room/8/1.png'),
          title: '青州博物馆项目工地智慧展馆',
          text: '特色区域包含AI智能识别系统，质量知识竞答系统，360度全息投影，智慧工地大数据中心，虚拟消防灭火系统，VR安全体验；AI智能识别系统对进入作业区域的人员进行自动识别，若检测到人员未佩戴安全帽，可立即报警。'
        },
      ]
    }
  },
  methods: {
    siteClick(id) {
      this.$router.push({
        path: 'roomDetail', query: {
          index: id
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 2.9rem;
  width: 100%;
  background: url("./img/banner/4.jpg");
  background-size: 100% 100%;
}

.box2 {
  width: 10rem;
  margin: .34rem auto .6rem;
  text-align: center;

  a {
    text-decoration: none;
  }

  .el-menu-item {
    width: 2rem;
    font-size: .2rem;
    height: .72rem;
    line-height: .72rem;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 3px solid #E70F20;
    color: #E70F20;
  }

  .el-menu--horizontal > .el-menu-item {
    color: #000;
  }
}

.box3 {
  width: 12rem;
  margin: 0 auto;

  .main {
    height: 2.2rem;
    background: #FBFBFB;
    display: flex;
    position: relative;
    margin-bottom: .3rem;
    cursor: pointer;

    img.lef {
      width: 3.6rem;
      height: 2.2rem;
    }

    div {
      height: 1.6rem;
      margin: .3rem 0 0 .57rem;

      p.tit {
        font-size: .26rem;
      }

      p.txt {
        width: 6.5rem;
        font-size: .18rem;
        color: #595757;
        line-height: .36rem;
        text-align: justify;
        margin-top: .23rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }

    span {
      position: absolute;
      width: .38rem;
      height: .38rem;
      background: url("../../assets/images/more.png");
      background-size: 100% 100%;
      right: .32rem;
      bottom: .35rem;
      cursor: pointer;
    }
  }
}
</style>
